import { render, staticRenderFns } from "./campaignCreateBrush.vue?vue&type=template&id=58c400f4"
import script from "./campaignCreateBrush.vue?vue&type=script&lang=js"
export * from "./campaignCreateBrush.vue?vue&type=script&lang=js"
import style0 from "./campaignCreateBrush.vue?vue&type=style&index=0&id=58c400f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports